<script lang="ts">
	import { Card, Pagenation, InlineButton, TopBottom } from "@hitit/new_ui";
	//UI
	//Utils
	import { processingDate } from "@hitit/hub/src/v7/utils";
	//Types
	import type { NewsVisitDTO } from "@hitit/api";
	//Props
	export let visitDTOs: NewsVisitDTO[];
	//Constants
	const divide = 10;
	//Variables
	let open = false;
	let presentPage = 0;

	$: totalPage = Math.ceil(visitDTOs.length / divide);
	$: if (presentPage > totalPage)
		presentPage = totalPage == 0 ? 0 : totalPage - 1;
	$: dividePage = divideDtos(visitDTOs, divide, presentPage);

	//Functions
	function divideDtos(
		dtos: NewsVisitDTO[],
		divideCount: number,
		currentPage: number
	) {
		const start = divideCount * currentPage;
		const end = start + divideCount;
		return dtos.slice(start, end);
	}
	//Do
</script>

<Card noPadding>
	<div class="container">
		<div class="header">
			<span class="count">읽음 : {visitDTOs.length}</span>
			<InlineButton on:click={() => (open = !open)}>
				<span class="icon">
					<TopBottom top={open} />
				</span>
			</InlineButton>
		</div>
		{#if open}
			<div class="t-header">
				<div class="name col">유저 명</div>
				<div class="view-count col">조회 일</div>
				<div class="date col">조회 수</div>
			</div>
			<div class="t-body">
				{#each dividePage as visitDTO}
					<div class="visit row">
						<div class="name col">
							{visitDTO.userName}
						</div>
						<div class="view-count col">
							{visitDTO.viewCount}
						</div>
						<div class="date col">
							{processingDate(visitDTO.readDate)}
						</div>
					</div>
				{/each}
			</div>
			<div class="pagenation">
				<Pagenation
					buttonCallback={(n) => (presentPage = n)}
					presentPage={presentPage}
					totalPage={totalPage}
				/>
			</div>
		{/if}
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px 10px;
		box-sizing: border-box;

		.header {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.count {
				font-size: 1.25rem;
				font-weight: 600;
				color: #46474b;
			}

			.icon {
				display: flex;
				width: 19.8px;
				height: 10px;
			}
		}
		.t-header {
			display: none;
			text-align: center;
			.col {
				font-size: 1.25rem;
				color: #6d6f76;
				width: 33.3%;
				max-width: 33.3%;
			}
		}
		.t-body {
			display: flex;
			flex-direction: column;
			margin-top: 10px;
			.row {
				display: flex;
				flex-wrap: wrap;
				padding: 10px 0px;
				gap: 10px 0px;
				&:not(:last-child) {
					border-bottom: 1px solid #d3d4da;
				}

				.name {
					width: 100%;
					max-width: 100%;
					color: #46474b;
					font-weight: 500;
				}
				.view-count,
				.date {
					max-width: 50%;
					width: 50%;
					font-size: 0.875rem;
					color: #6d6f76;
				}
				.date {
					text-align: right;
				}
			}
		}
		.pagenation {
			margin-top: 10px;
		}
	}
	@include DesktopSize {
		.container {
			padding: 30px;
			.header {
				.count {
					font-size: 2.125rem;
				}
				.icon {
					width: 27.8px;
					height: 14px;
				}
			}

			.t-header {
				display: flex;
				margin-top: 30px;
			}
			.t-body {
				margin-top: 0px;
				.row {
					padding: 20px 0px;
					.view-count,
					.date,
					.name {
						max-width: 33.3% !important;
						width: 33.3% !important;
						font-size: 1.25rem !important;
						color: #46474b !important;
						font-weight: 200 !important;
						text-align: center !important;
					}

					.date {
						order: 1;
					}
					.view-count {
						order: 2;
					}
				}
			}
		}
	}
</style>
